import { render, staticRenderFns } from "./FinalizacaoAnexos2.vue?vue&type=template&id=07861e91"
import script from "./FinalizacaoAnexos2.vue?vue&type=script&lang=js"
export * from "./FinalizacaoAnexos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports